export default "__VITE_ASSET__UuI_rI9i__"